import { memo } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import type { Screen } from '../types';

interface FooterProps {
  onNavigate?: (screen: Screen) => void;
}

export const Footer = memo(function Footer({ onNavigate }: FooterProps) {
  const { t } = useLanguage();
  
  const handleLinkClick = (screen: Screen) => {
    onNavigate?.(screen);
  };
  
  return (
    <footer className="bg-white/80 backdrop-blur-md border-t border-slate-200 mt-8">
      <div className="max-w-md mx-auto px-4 py-6">
        <div className="flex justify-center gap-6 mb-4 flex-wrap">
          <button
            onClick={() => handleLinkClick('about')}
            className="text-slate-600 hover:text-primary transition-smooth font-semibold text-sm"
          >
            {t('footer.about')}
          </button>
          <button
            onClick={() => handleLinkClick('faq')}
            className="text-slate-600 hover:text-primary transition-smooth font-semibold text-sm"
          >
            {t('footer.faq')}
          </button>
          <button
            onClick={() => handleLinkClick('privacy')}
            className="text-slate-600 hover:text-primary transition-smooth font-semibold text-sm"
          >
            {t('footer.privacy')}
          </button>
        </div>
        <p className="text-center text-slate-400 text-sm font-medium">
          {t('footer.copyright')}
        </p>
      </div>
    </footer>
  );
});